import { UserOutlined } from "@ant-design/icons";
import { Flex } from "common/components/flex/flex";
import { Link } from "react-router-dom";
import * as styles from "./candidateLinkItem.module.scss";

export const CandidateLinkItem = ({
  candidateId,
  jobEntryId,
  name,
  children,
}) => {
  const href = `/candidates/detail/${candidateId}?tab=jobs&jobEntry=${jobEntryId}`;

  return (
    <Link to={href} className={styles.candidateLinkItem}>
      <UserOutlined className={styles.candidateLinkItem__icon} />
      <Flex direction="column" gap={4} style={{ lineHeight: 1.2 }}>
        <span className="font-weight-heavy">{name}</span>
        {children}
      </Flex>
    </Link>
  );
};
